const eventsData = [
  {
    id: 'it-quiz',
    title: 'Ohara Knowledge Hunt',
    status: 'Closed',
    subtitle: 'IT Quiz',
    category: 'Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 2 members',
    fee: '₹250 per team',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Ohara Knowledge Hunt is a fast-paced tech quiz inspired by the wisdom of Ohara\'s scholars. It challenges participants with elimination rounds that test logical thinking, technical knowledge, and awareness of modern IT trends. From core CS concepts to problem-solving and current technologies, only the sharpest minds will advance. In Ohara, knowledge is the ultimate treasure!',
    image: '/assets/events/it-quiz.png',
    rules: [
      'Team Size: Exactly 2 members',
      'The quiz will have 3–4 rounds with eliminations',
      'Participants should have basic knowledge of computer science and current IT trends',
      'Use of mobile phones or any electronic devices is strictly prohibited',
      'Any cheating or misconduct will result in immediate disqualification',
      'Decisions by the organizers and quizmasters are final and binding'
    ],
    coordinators: [
      { name: 'Manasa', phone: '+91 7975421862' },
      { name: 'Sachchidanand M Madik', phone: '+91 6362724717' }
    ],
    registrationLink: 'https://forms.gle/nmwjt91Sxt4KMt8F7',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'web-designing',
    title: 'Franky`s Workshop',
    status: 'Closed',
    subtitle: 'Web Designing',
    category: 'Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 2 members',
    fee: '₹250 per team',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Franky\'s Workshop is a dynamic web-design showdown where creativity meets engineering—just like Franky\'s inventions. Participants must craft responsive, visually striking web pages using modern design principles and wireframes. This event highlights innovation, structure, and flair as teams bring their ideas to life through clean design and strong functionality.',
    image: '/assets/events/web-designing.png',
    rules: [
      'Team Size: Exactly 2 members',
      'Competitors are expected to have a solid grasp of HTML, CSS, and JavaScript to create responsive and visually appealing web pages',
      'Knowledge of Figma or other wireframing platforms is mandatory',
      'Participants must bring their own laptops',
      'Participants may use AI tools, but only to a limited extent',
      'Internet access will be provided',
      'Judgment based on creativity, design, responsiveness and functionality'
    ],
    coordinators: [
      { name: 'Nachiket Hegde', phone: '+91 9353154253' },
      { name: 'Nehasai A', phone: '+91 9481565751' }
    ],
    registrationLink: 'https://forms.gle/SwhsKFkF8yiPhe8j7',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'coding',
    title: 'Vegapunk`s Code Lab',
    status: 'Closed',
    subtitle: 'Coding and Debugging',
    category: 'Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 2 members',
    fee: '₹250 per team',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Vegapunk\'s Code Lab is a fast-paced coding and debugging challenge inspired by the genius of Dr. Vegapunk. Teams will tackle three dynamic rounds that test logic, speed, and problem-solving skills. Tasks are revealed on the spot, pushing participants to think fast and code smarter. Step in and prove your innovation in the ultimate tech arena!',
    image: '/assets/events/coding.png',
    rules: [
      'Team Size: Exactly 2 members',
      'Participants are required to have basic familiarity with C, C++, or Java',
      'Details of each round’s tasks will be revealed shortly before the round begins',
      'Each team must ensure that at least one participant possesses a HackerRank account',
      'All contestants must work exclusively on the systems provided by the organizers',
      'The event includes both coding and debugging challenges'
    ],
    coordinators: [
      { name: 'Abhiram H N', phone: '+91 9113271872' },
      { name: 'Abhishek P L', phone: '+91 8792405440' }
    ],
    registrationLink: 'https://forms.gle/v1tWKWHd3PRZFW5P6',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'it-manager',
    title: 'Fleet Admiral’s Command Room',
    status: 'Closed',
    subtitle: 'IT Manager',
    category: 'Managerial',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Individual',
    fee: '₹150 per participant',
    prizes: {
      winner: '₹2000',
    },
    description: 'Fleet Admiral\'s Command Room is a high-intensity IT management challenge inspired by the strategic command of the Marines. Participants must think like top-level decision-makers, using logic, leadership, and analytical skills to navigate complex technical tasks. This event tests precision, clarity, and strategic execution—reflecting the discipline and sharp judgment of a true Fleet Admiral.',
    image: '/assets/events/it-manager.png',
    rules: [
      'Individual participation only',
      'Participants should carry their own laptops, as certain rounds may require them',
      'Communication or collaboration between participants during rounds is strictly prohibited',
      'Mobile phones and any external gadgets must remain unused during rounds unless explicitly allowed by the event coordinators',
      'Any form of cheating, use of unfair means, or disruptive behavior will lead to immediate disqualification'
    ],
    coordinators: [
      { name: 'Om', phone: '+91 7203836286' },
      { name: 'Kaushik', phone: '+91 7892473384' }
    ],
    registrationLink: 'https://forms.gle/NVKpxjQQzopJrowc8',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'photography',
    title: 'Ussop`s Snapshot Studio',
    status: 'Closed',
    subtitle: 'Photography and Videography',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Individual',
    fee: '₹150 per participant',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Inspired by the sharpshooter of the Straw Hats, Usopp\'s Snapshot Studio challenges participants to capture moments with precision, creativity, and quick thinking. With themes revealed on the spot, contestants must rely on observation and timing—just like Usopp\'s perfect aim. This on-the-spot photography battle tests skill, originality, and storytelling.',
    image: '/assets/events/photography.png',
    rules: [
      'Individual participation only',
      'The event consists of 3 rounds, with themes given on the spot',
      'Entries must be captured only on a mobile phone or DSLR - no other devices or AI-generated media are allowed',
      'No editing is permitted unless organizers give permission',
      'Only original files must be submitted - metadata/time will be verified',
      'All photos/videos must follow the theme and be captured within the event time',
      'Participants must bring and use their own accessories (chargers, gimbals, etc.)',
      'Participants must not harm nature, property, or people while capturing',
      'Judges\' decisions are final',
      'Any rule violation will result in disqualification',
    ],
    coordinators: [
      { name: 'Krishna L', phone: '+91 9113927440' },
      { name: 'Supraj', phone: '+91 8618593475' }
    ],
    registrationLink: 'https://forms.gle/R1FzuJn1VP97XdZ47',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'surprise-event',
    title: 'Gum-Gum Wildcard Arena',
    status: 'Closed',
    subtitle: 'Surprise Event',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 4 members',
    fee: '₹300 per team',
    prizes: {
      winner: '₹3000',
      runnerUp: '₹1500'
    },
    description: 'Gum-Gum Wildcard Arena is a fun, unpredictable surprise event inspired by Luffy\'s chaotic and spontaneous energy. Participants must rely on quick thinking, adaptability, and a fearless spirit as every round brings unexpected twists. Just like Luffy\'s wild moves, this event is full of surprises where anything can happen—and only the most flexible minds will thrive!',
    image: '/assets/events/surprise-event.png',
    rules: [
      'Team Size: Exactly 4 members',
      'Rules will be revealed on the spot',
      'Phones are allowed but will be under the control of event organizers (will be given to participants if required for the game or at the end of the event)',
      'Result from the judges is final.'
    ],
    coordinators: [
      { name: 'Swapna T R', phone: '+91 6363441695' },
      { name: 'Priya R G', phone: '+91 9980870709' }
    ],
    registrationLink: 'https://forms.gle/PPXQqWoiBTJKvmScA',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'quick-shot',
    title: 'Shanks Instinct Trials',
    status: 'Closed',
    subtitle: 'Quick-Shot',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 2 members',
    fee: '₹250 per team',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Shanks Instinct Trials is a fast-paced, mind-sharpening challenge designed to test reflexes, logic, and instinctive decision-making. Each round brings unexpected tasks that push participants to think quickly under pressure—just like Shanks\' fearless intuition. Teams must rely on focus, teamwork, and quick judgment to survive the eliminations and claim victory!',
    image: '/assets/events/quick-shot.png',
    rules: [
      'Team size: Exactly 2 members',
      'Rules for each round will be explained before the round begins',
      'Participants must clear all doubts before the game starts',
      'Punctuality is expected throughout the event',
      'Mobile phones and the internet cannot be used during the event',
      'After every round, the lowest-scoring team will be eliminated',
      'Additional instructions will be provided at the time of participation',
      'The decision of the judges will be final'
    ],
    coordinators: [
      { name: 'Prashanth', phone: '+91 8496840447' },
      { name: 'Vijayshree krishna', phone: '+91 6362664539' }
    ],
    registrationLink: 'https://forms.gle/hkZTNE51qPurWi66A',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'treasure-hunt',
    title: 'Laugh Tale Treasure Quest',
    status: 'Closed',
    subtitle: 'Treasure Hunt',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Maximum 4 members',
    fee: '₹300 per team',
    prizes: {
      winner: '₹3000'
    },
    description: 'Laugh Tale Treasure Quest is an adventurous, One Piece–themed treasure hunt where participants solve clues, crack puzzles, and navigate challenges to reach the final treasure. Designed to test teamwork, problem-solving, and quick thinking, this quest brings the thrill of exploration and the spirit of piracy to life. Teams must follow clues, avoid restricted zones, and complete tasks as they race toward the ultimate prize—the treasure of Laugh Tale!',
    image: '/assets/events/treasure-hunt.png',
    rules: [
      'Team size: Maximum 4 members',
      'Further information is provided at the time of participation',
      'Entry is prohibited to the restricted areas',
      'No damaging property or cheating',
      'Judge’s decisions will be final and cannot be disputed'
    ],
    coordinators: [
      { name: 'Prajwal Bhat', phone: '+91 6360889658' },
      { name: 'Shrinivasa Gowda', phone: '+91 7483117363' }
    ],
    registrationLink: 'https://forms.gle/CXC4K21FedzkR1e96',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'tech-charades',
    title: 'Luffy’s Guess-It-Wrong Arena',
    status: 'Closed',
    subtitle: 'Tech Charades',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 2 members',
    fee: '₹250 per team',
    prizes: {
      winner: '₹2000',
      runnerUp: '₹1000'
    },
    description: 'Luffy`s Guess-It-Wrong Arena brings a fun, chaotic twist to tech charades, inspired by Luffy`s legendary inability to guess anything right. This event challenges teams to rely purely on expressions, actions, and trust in their partners—mirroring the theme of freedom, friendship, and belief in each other. It`s energetic, unpredictable, and guaranteed to keep the audience entertained!',
    image: '/assets/events/tech-charades.png',
    rules: [
      'Team size: Exactly 2 members',
      'Mobile phones and electronic devices are strictly prohibited during the game',
      'Participants may use only gestures, facial expressions, and body movements to convey the phrase',
      'Any form of cheating will lead to immediate disqualification',
      'Teams must report on time for each round; late arrivals may result in penalties or disqualification',
      'Judges decision is final'
    ],
    coordinators: [
      { name: 'Lavanya', phone: '+91 7899208491' },
      { name: 'Mamatha', phone: '+91 8951850517' }
    ],
    registrationLink: 'https://forms.gle/UE8k5jpLKUGEcjvQ6',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'bgmi',
    title: 'Zoro’s Battle Arena',
    status: 'Closed',
    subtitle: 'Gaming',
    category: 'Non-Technical',
    date: 'December 4, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 4 members',
    fee: '₹300 per team',
    prizes: {
      winner: '₹3000',
      runnerUp: '₹1500'
    },
    description: 'Zoro`s Battle Arena is an intense mobile-gaming showdown inspired by the fearless strength and precision of Roronoa Zoro. Teams battle through multiple rounds where skill, focus, and strategy decide the outcome. Only those who stay sharp, adapt quickly, and fight with determination will survive the arena and claim victory!',
    image: '/assets/events/bgmi.png',
    rules: [
      'Team Size: Exactly 4 players per team',
      'Any foul playor cheating, including Aim Bot, Game client modification and exploiting bugs or glitches will result in immediate disqualifictaion',
      'Only Android or iOS mobile phones are allowed; Emulators or Tablets are strictly prohibited',
      'Participants must be ready with their required accessories before joining the game',
      'Wi-Fi will be provided',
      'Bring your own chargers and headphones',
      'Judges decision is final'
    ],
    coordinators: [
      { name: 'Nandan R Nayaka', phone: '+91 9036621553' },
      { name: 'Lohith Kumar', phone: '+91 7483347390' }
    ],
    registrationLink: 'https://forms.gle/igLgZG6U6xXfRFG97',
    brochureLink: '/brochures/brochure.pdf'
  },
  {
    id: 'dance',
    title: 'Wano Rythms Arena',
    status: 'Closed',
    subtitle: 'Dance Competition',
    category: 'Non-Technical',
    date: 'December 5, 2025',
    time: '10:00 AM',
    teamSize: 'Exactly 4-6 members',
    fee: '₹300 per team',
    prizes: {
      winner: '₹3000',
    },
    description: 'Wano Rhythms Arena celebrates the spirit of freedom, unity, and unbreakable trust—values deeply rooted in One Piece and perfectly reflected in dance. Teams perform with emotion, harmony, and storytelling that showcase friendship and belief in each other. This event blends cultural rhythm with powerful team synergy to bring the theme alive on stage.',
    image: '/assets/events/dance.png',
    rules: [
      'Team size: 4-6 members',
      'Theme - Social Media Takeover',
      'The dance performance should strictly adhere to the theme.',
      'Time limit: Maximum 6 minutes',
      'Music must be submitted in a pendrive before the performance',
      'Participants must bring and manage their own props, costumes and materials. nothing will be provided',
      'Vulgarity or offensive content will lead to disqualification',
      'Judges\' decision will be final.'
    ],
    coordinators: [
      { name: 'Damini A V', phone: '+91 8549045344' },
      { name: 'Rachita', phone: '+91 8088997674' }
    ],
    registrationLink: 'https://forms.gle/Jx2yRVPAwG1NJjgW8',
    brochureLink: '/brochures/brochure.pdf'
  },
];

export default eventsData;
